import { switchAnatomy as parts } from '@chakra-ui/anatomy'
import { calc, cssVar } from '@chakra-ui/theme-tools'

const $width = cssVar('switch-track-width')
const $height = cssVar('switch-track-height')

const $diff = cssVar('switch-track-diff')
const diffValue = calc.subtract($width, $height)

const $translateX = cssVar('switch-thumb-x')

export const Switch = {
  parts: parts.keys,
  baseStyle: {
    container: {
      [$diff.variable]: diffValue,
      [$translateX.variable]: $diff.reference,
      _rtl: {
        [$translateX.variable]: calc($diff)
          .negate()
          .toString()
      }
    },
    track: {
      borderRadius: 'full',
      p: '2px',
      width: [$width.reference],
      height: [$height.reference],
      transitionProperty: 'common',
      transitionDuration: 'fast',
      bg: 'brand.ghost',
      _focus: {
        boxShadow: 'outline'
      },
      _disabled: {
        opacity: 0.4,
        cursor: 'not-allowed'
      },
      _checked: {
        bg: 'brand.main'
      }
    },
    thumb: {
      bg: 'white',
      transitionProperty: 'transform',
      transitionDuration: 'normal',
      borderRadius: 'inherit',
      width: [$height.reference],
      height: [$height.reference],
      _checked: {
        transform: `translateX(${$translateX.reference})`
      }
    }
  },
  sizes: {
    sm: {
      container: {
        [$width.variable]: '1.375rem',
        [$height.variable]: '0.75rem'
      }
    },
    md: {
      container: {
        [$width.variable]: '1.875rem',
        [$height.variable]: '1rem'
      }
    },
    lg: {
      container: {
        [$width.variable]: '2.875rem',
        [$height.variable]: '1.5rem'
      }
    }
  },
  defaultProps: {
    size: 'md',
    colorScheme: 'blue'
  }
}
